import { Button } from "../../../shadcnComponents/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../shadcnComponents/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../shadcnComponents/ui/table";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../../shadcnComponents/ui/avatar";
import { Label } from "../../../shadcnComponents/ui/label";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../shadcnComponents/ui/select";
import { IndianRupee } from "lucide-react";
import { Input } from "../../../shadcnComponents/ui/input";
import { useToast } from "../../../shadcnComponents/ui/use-toast";
import { useGeneralSettings } from "../../../Providers/General";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../shadcnComponents/ui/alert-dialog";
import { SidebarTrigger } from "@/shadcnComponents/ui/sidebar";

const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export function AdminCollabEarning() {
  const [showAddEarningModal, setShowAddEarningModal] = useState(false);
  const [allCreators, setAllCreators] = useState([]);
  const [collabTransactions, setCollabTransactions] = useState([]);

  const getCreators = useCallback(async () => {
    try {
      const response = await fetch(`${host}/developer/getallCreator`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": "true",
          jwtToken: localStorage.getItem("jwtTokenD"),
        },
      });
      const json = await response.json();
      if (json.success) {
        const filterUniqueCreators = json?.creators.filter((creator, index) => {
          return (
            json?.creators.findIndex((obj) => obj.email === creator.email) ===
            index
          );
        });
        setAllCreators(filterUniqueCreators);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  const getCollabTransactions = useCallback(async () => {
    try {
      const response = await fetch(
        `${host}/developer/getInfluWalletTxn/?variant=collab_earning_credit`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        }
      );
      const json = await response.json();
      if (json.success) {
        setCollabTransactions(json?.txn?.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  const TotalCollabCredit = useMemo(() => {
    const filteredCreditTxns = collabTransactions.filter(
      (txn) => txn.transactionType === "credit"
    );
    return filteredCreditTxns.reduce((acc, curr) => acc + curr.amount, 0);
  }, [collabTransactions]);

  useEffect(() => {
    getCreators();
    getCollabTransactions();
  }, [getCreators, getCollabTransactions]);

  return (
    <>
      {showAddEarningModal && (
        <AddEarningModal
          open={showAddEarningModal}
          onOpenChange={setShowAddEarningModal}
          allCreators={allCreators}
          fetchCollabTransactions={getCollabTransactions}
        />
      )}
      <div className="flex-col flex w-full h-full">
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-6">
          <SidebarTrigger />
          <h1 className="text-2xl font-bold">Earnings</h1>
        </header>
        <div className="w-full space-y-4 mt-6">
          <div className="space-y-4">
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
              <Card>
                <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                  <CardTitle className="text-sm font-medium">
                    Total Collab Earning
                  </CardTitle>
                  <IndianRupee className="w-6 h-6" />
                </CardHeader>
                <CardContent>
                  <div className="text-2xl font-bold">₹{TotalCollabCredit}</div>
                  {/* <p className="text-xs text-muted-foreground">
                    +20.1% from last month
                  </p> */}
                </CardContent>
              </Card>
            </div>
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-semibold">Earnings Table</h2>
              <Button onClick={() => setShowAddEarningModal(true)}>
                Add Another Earning
              </Button>
            </div>
            <CollabEarningsTable collabTnxs={collabTransactions} />
          </div>
        </div>
      </div>
    </>
  );
}

function AddEarningModal({
  open,
  onOpenChange,
  allCreators,
  fetchCollabTransactions,
}) {
  const generalState = useGeneralSettings();
  const [sentOTP, setsentOTP] = useState(false);
  const [otp, setOtp] = useState("");

  const [influencer, setInfluencer] = useState(null);
  const [collab, setCollab] = useState(null);
  const [influAllCollab, setInfluAllCollab] = useState(null);
  // const [filteredCreators, setFilteredCreators] = useState([]);
  const [creatorSearchQuery, setCreatorSearchQuery] = useState("");
  const [collabSearchQuery, setCollabSearchQuery] = useState("");
  // const [filteredCollabs, setFilteredCollabs] = useState([]);
  const [earning, setEarning] = useState(0);
  const [txnType, setTxnType] = useState("credit");
  const { toast } = useToast();

  const debouncedCreatorSearchQuery = useDebounce(creatorSearchQuery, 300);
  const debouncedCollabSearchQuery = useDebounce(collabSearchQuery, 300);

  const fetchInfluencerCollabs = useCallback(async (influencerId) => {
    try {
      const response = await fetch(
        `${host}/developer/influencer/getAllBrandCollabs/?influencerId=${influencerId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
        }
      );
      const json = await response.json();
      if (json.success) {
        setInfluAllCollab(json.brandCollabs);
        // setFilteredCollabs(json.brandCollabs);
      } else {
        console.error("Error fetching influencer collabs");
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  const filteredCreators = useMemo(() => {
    if (debouncedCreatorSearchQuery?.trim() === "") return [];
    return allCreators?.filter((creator) =>
      creator.name
        .toLowerCase()
        .includes(debouncedCreatorSearchQuery.toLowerCase())
    );
  }, [debouncedCreatorSearchQuery, allCreators]);

  const filteredCollabs = useMemo(() => {
    return influAllCollab?.filter((collab) =>
      collab?.collabId?.campaignInfo?.campaignName
        ?.toLowerCase()
        .includes(debouncedCollabSearchQuery.toLowerCase())
    );
  }, [debouncedCollabSearchQuery, influAllCollab]);

  const handleInfluencerSelect = (influencerId) => {
    setCollab(null);
    const influencer = allCreators.find(
      (creator) => creator._id === influencerId
    );
    setInfluencer(influencer);
    fetchInfluencerCollabs(influencerId);
  };

  const handleCollabSelect = (influCollabId) => {
    const collab = influAllCollab.find(
      (collab) => collab._id === influCollabId
    );
    setCollab(collab);
  };

  const handleSearchCreator = (e) => {
    setCreatorSearchQuery(e.target.value);
  };

  const handleSearchCollab = (e) => {
    setCollabSearchQuery(e.target.value);
  };

  const handleSelectTxnType = (value) => {
    setTxnType(value);
  };

  const validateForm = () => {
    if (!influencer || !collab || !earning || !txnType) {
      toast({
        title: "Please fill all the fields",
        variant: "destructive",
      });
      return false;
    }
    return true;
  };

  const sendOtp = async () => {
    if (!validateForm()) return;

    try {
      generalState?.setLoading(true);
      const response = await fetch(
        `${host}/developer/sendMsg?message=DevLogin&subject=Anchors`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": "true",
          },
        }
      );
      const json = await response.json();
      if (json?.MessageID) {
        setsentOTP(true);
      } else {
        console.log("Some error occurred", json);
      }
    } catch (error) {
      console.error(error);
    } finally {
      generalState.setLoading(false);
    }
  };

  const checkOtp = async () => {
    try {
      generalState.setLoading(true);
      const response = await fetch(`${host}/developer/verifyOtp`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": "true",
        },
        body: JSON.stringify({
          otp: otp,
        }),
      });
      const data = await response.json();
      if (data.success) {
        return true;
      } else {
        toast({
          title: data?.error,
          variant: "destructive",
        });
        return false;
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Some error occurred",
        variant: "destructive",
      });
    } finally {
      generalState.setLoading(false);
    }
    return false;
  };

  const handleSubmit = async () => {
    console.log(influencer?._id, collab?.collabId?._id, earning, txnType);

    if (!validateForm()) {
      return;
    }

    const isValidOtp = await checkOtp();
    if (!isValidOtp) {
      toast({
        title: "OTP verification failed",
        variant: "destructive",
      });
      return;
    }

    try {
      const response = await fetch(
        `${host}/developer/influencer/addCollabEarning`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": "true",
            jwtToken: localStorage.getItem("jwtTokenD"),
          },
          body: JSON.stringify({
            influencerId: influencer?._id,
            collabId: collab?.collabId?._id,
            amount: earning,
            txnType: txnType,
          }),
        }
      );
      const json = await response.json();
      if (json?.success) {
        console.log("Earning added successfully");
        toast({
          title: "Earning added successfully",
        });
        fetchCollabTransactions();
        onOpenChange(false);
      } else {
        console.error("Error adding earning");
        toast({
          title: "Error adding earning",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Error adding earning",
        variant: "destructive",
      });
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:max-w-[500px] max-h-[600px] overflow-y-scroll">
        <AlertDialogHeader>
          <AlertDialogTitle>Add Another Earning</AlertDialogTitle>
          <AlertDialogDescription>
            Fill in the details below to add another earning
          </AlertDialogDescription>
        </AlertDialogHeader>
        <form className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="influencer">Select Influencer</Label>
            <Select onValueChange={handleInfluencerSelect}>
              <SelectTrigger id="influencer">
                {influencer ? (
                  <div>{influencer?.name}</div>
                ) : (
                  <SelectValue
                    placeholder="Select Influencer"
                    className="p-2"
                  />
                )}
              </SelectTrigger>
              <SelectContent className="max-h-[300px]">
                <div className="p-2">
                  <Input
                    placeholder="Search Influencer"
                    value={creatorSearchQuery}
                    onChange={(e) => handleSearchCreator(e)}
                  />
                </div>
                {filteredCreators?.map((creator, index) => (
                  <SelectItem key={index} value={creator?._id}>
                    <div className="flex items-center gap-3">
                      <Avatar>
                        <AvatarImage
                          src={creator?.profile}
                          alt={creator?.name}
                        />
                        <AvatarFallback>
                          {creator?.name.charAt(0)}
                        </AvatarFallback>
                      </Avatar>
                      <div className="flex flex-col gap-1">
                        <span className="line-clamp-1 max-w-[300px]">
                          {creator?.name}
                        </span>
                        <span className="text-xs text-muted-foreground">
                          {creator?.email}
                        </span>
                      </div>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {influAllCollab?.length > 0 && (
            <div className="space-y-2">
              <Label htmlFor="collab">Select Collab</Label>
              <Select onValueChange={handleCollabSelect}>
                <SelectTrigger id="collab">
                  {collab ? (
                    <div className="text-sm text-start">
                      {collab?.collabId?.campaignInfo?.campaignName}
                    </div>
                  ) : (
                    <SelectValue placeholder="Select Collab" className="p-2" />
                  )}
                </SelectTrigger>
                <SelectContent className="max-h-[250px]">
                  <div className="p-2">
                    <Input
                      placeholder="Search Collab"
                      value={collabSearchQuery}
                      onChange={(e) => handleSearchCollab(e)}
                    />
                  </div>
                  {filteredCollabs?.map((collab, index) => (
                    <SelectItem key={index} value={collab?._id}>
                      <div className="flex items-center gap-3">
                        <span className="line-clamp-1 max-w-[300px]">
                          {collab?.collabId?.campaignInfo?.campaignName}
                        </span>
                        <span className="text-xs text-muted-foreground">
                          {collab?.companyUrl}
                        </span>
                      </div>
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}
        </form>
        {collab && (
          <Card className="mt-4">
            <CardHeader>
              <CardTitle>Collab Details</CardTitle>
            </CardHeader>
            <CardContent className="space-y-2">
              <p>
                <span className="font-bold">Total Impressions: </span>
                <span>{collab?.postTracking?.impressions}</span>
              </p>
              <p>
                <span className="font-bold">Post Link: </span>
                <a
                  target="_blank"
                  href={collab?.trackingLink}
                  className="text-blue-500 hover:underline"
                >
                  Post Link
                </a>
              </p>
              <p>
                <span className="font-bold">Live Date: </span>
                <span>{new Date(collab?.liveAt)?.toLocaleString()}</span>
              </p>
              <p>
                <b>Likes: </b> {collab?.postTracking?.likes} | <b>Comments: </b>
                {collab?.postTracking?.comments} | <b>Reposts: </b>
                {collab?.postTracking?.reposts}
              </p>
              <p>
                <b>Expected Earning: </b> ₹
                {collab?.approxPrice?.["$numberDecimal"]}
              </p>
              <p>
                <b>Earn Max Cap: </b>
                {collab?.maxPrice}
              </p>
              <hr />
              <div className="space-y-2">
                <Label htmlFor="txn_type">Txn type</Label>
                <Select onValueChange={handleSelectTxnType}>
                  <SelectTrigger id="txn_type">
                    {txnType ? txnType : "Select Transaction Type"}
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="credit">Credit</SelectItem>
                    <SelectItem value="debit">Debit</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label htmlFor="earning">Enter Earning</Label>
                <Input
                  id="earning"
                  type="number"
                  placeholder="Enter earning amount"
                  value={earning}
                  onChange={(e) => setEarning(Number(e.target.value))}
                />
              </div>
            </CardContent>
          </Card>
        )}
        {sentOTP && (
          <div className="flex flex-col gap-2">
            <Label htmlFor="otp">Enter OTP</Label>
            <Input
              id="otp"
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          {!sentOTP ? (
            <Button type="submit" onClick={sendOtp}>
              Submit
            </Button>
          ) : (
            <Button onClick={handleSubmit}>Confirm</Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

function CollabEarningsTable({ collabTnxs }) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Influencer</TableHead>
          <TableHead>Collab Name</TableHead>
          <TableHead>Collab Earning</TableHead>
          <TableHead>Created On</TableHead>
          <TableHead>Added By</TableHead>
          <TableHead>Subscription Plan</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {collabTnxs?.map((row, index) => (
          <TableRow key={index}>
            <TableCell>
              <div className="flex items-center space-x-3">
                <Avatar>
                  <AvatarImage
                    src={row?.influencerId?.profile}
                    alt={row?.influencerId?.name}
                  />
                  <AvatarFallback>
                    {row?.influencerId?.name?.charAt(0)}
                  </AvatarFallback>
                </Avatar>
                <span>{row?.influencerId?.name}</span>
              </div>
            </TableCell>
            <TableCell>{row?.collabId?.campaignInfo?.campaignName}</TableCell>
            <TableCell>₹{row?.amount}</TableCell>
            <TableCell>{new Date(row?.createdAt)?.toLocaleString()}</TableCell>
            <TableCell>{row?.addedBy?.userType}</TableCell>
            <TableCell>
              {row?.influencerId?.activePlan?.planID?.planName}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
